import { render } from "./FormResetPassword.vue?vue&type=template&id=1a7e53ec&scoped=true"
import script from "./FormResetPassword.vue?vue&type=script&lang=js"
export * from "./FormResetPassword.vue?vue&type=script&lang=js"

import "./FormResetPassword.vue?vue&type=style&index=0&id=1a7e53ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a7e53ec"

export default script